module.exports = {
  MultipleChoice: {
    PluginName: "Una Selección",
    content_box_name: "Contenedor  ",
    Statement:
      "Esta es una pregunta con varias opciones para responder. Sólo una puede ser correcta. Puedes escribir aquí el enunciado de la pregunta",
    Question: "Pregunta",
    Answer: "Respuesta",
    Feedback: "Explicación",
    FeedbackMsg:
      "Aquí puedes incluir una explicación acerca de la respuesta. Puedes desactivar esta opción en la barra de herramientas.",
    TrueFeedbackMsg:
      '<span class="div-float-left-margin-right-8" ><img><svg id="Layer_1" data-name="Layer 1" height="25" width="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.74 14.85"><defs><style>.cls-1{fill:#31a148;}</style></defs><path class="cls-1" d="M8,19.43H7.89a1.59,1.59,0,0,1-1.29-.73,27.7,27.7,0,0,0-4.89-5.38,1.59,1.59,0,0,1,2-2.46A32.74,32.74,0,0,1,8,15.22,60.13,60.13,0,0,1,20.41,4.83a1.59,1.59,0,1,1,1.73,2.68A53,53,0,0,0,9.23,18.78,1.58,1.58,0,0,1,8,19.43Z" transform="translate(-1.13 -4.57)"/></svg></img></span>Aquí puede proporcionar algunos comentarios sobre la respuesta verdadera. Para deshabilitar esta función, desactívela en la barra de herramientas.',
    FalseFeedbackMsg:
      '<span class="div-float-left-margin-right-8" ><img><svg id="Layer_2" data-name="Layer 2" height="24" width="24"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.3 20.3"><defs><style>.cls-2{fill:#e01f26;}</style></defs><path class="cls-2" d="M20,22.15a2.15,2.15,0,0,1-1.51-.62l-16-16a2.13,2.13,0,0,1,3-3L21.53,18.52A2.13,2.13,0,0,1,20,22.15Z" transform="translate(-1.85 -1.85)"/><path class="cls-2" d="M4,22.15a2.13,2.13,0,0,1-1.5-3.63l16.05-16a2.13,2.13,0,0,1,3,3l-16,16.05A2.15,2.15,0,0,1,4,22.15Z" transform="translate(-1.85 -1.85)"/></svg></img></span>Aquí puede proporcionar algunos comentarios sobre la respuesta falsa. Para deshabilitar esta función, desactívela en la barra de herramientas.',
    ShowFeedback: "Mostrar Explicación",
    Number: "Número de Respuestas",
    ShowLettersInsteadOfNumbers: "Mostrar letras en lugar de números",
    ShowLetters: "Letras",
    ShowNumbers: "Números",
    QuizColor: "Color de la Pregunta",
    Color: "Color",
    correctAnswerFeedback: "Respuesta Correcta",
    notCount: "Este ejercicio no añade puntos a la nota",
    tryAgain: "Inténtalo de nuevo",
    seeAnswer: "Ver Respuesta",
    selectOption: "Por favor seleccione una opción",
    answerAll: "Por favor, asegúrese de marcar todas las opciones",
    checkAnswer: "Checar Respuesta",
    sendAnswer: "Enviar Respuesta",
    correctStatus: "¡Correcto!",
    wrongStatus: "Respuesta incorrecta",
    Shuffle: "Mezclar Las Opciones",
    WhichButtons: "Tipo de Botón",
    isMandatory: "Obligación de Respuesta",
    CheckAnswerText: "Texto del Botón Verificar Respuesta",
    TryAgainText: "Texto del Botón Intentar de Nuevo",
    SeeAnswerText: "Texto del Botón Ver Respuesta",
    ButtonStyle: "Estilo del Botón",
    ButtonBackground: "Color de Fondo del Botón",
    ButtonTextColor: "Color de Texto del Botón",
    ButtonBorderColor: "Color de Borde del Botón",
    ButtonBorderWidth: "Grosor del Borde del Botón",
    ButtonBorderRadius: "Radio de Borde del Botón",
    ButtonPadding: "Espaciado del Botón",
    ButtonFontSize: "Tamaño de Fuente del Botón",
    ButtonFontWeight: "Peso de Fuente del Botón",
    ButtonHoverBackground: "Color de Fondo al Pasar el Ratón",
  },
};
